export const formatSuggestionLabel = (key: string): string => {
  if (!key) return '';
  // Insert a space before any uppercase letters, then trim
  const withSpaces = key.replace(/([A-Z])/g, ' $1').trim();
  // Capitalize the first letter of each word
  return withSpaces
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
